import { render } from "./BaseTags.vue?vue&type=template&id=3be2e54e"
import script from "./BaseTags.vue?vue&type=script&lang=js"
export * from "./BaseTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__